import { render } from "./orderDataTemplate.vue?vue&type=template&id=03e01bd9"
import script from "./orderDataTemplate.vue?vue&type=script&lang=js"
export * from "./orderDataTemplate.vue?vue&type=script&lang=js"

import "./orderDataTemplate.vue?vue&type=style&index=0&id=03e01bd9&lang=scss"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__